import { LegalLayout, LegalSection } from "@/components/landing/LegalLayout";

export default function Confidentialite() {
  return (
    <LegalLayout
      testId="page-confidentialite"
      eyebrow="Vie privée"
      title="Politique de confidentialité"
      updated="juin 2026"
    >
      <LegalSection title="Responsable du traitement">
        <p>
          Le responsable du traitement des données collectées via ce site est l'entreprise
          individuelle <strong>Leadzi CHR</strong> (SIRET 791 545 387 00049). Pour toute question
          relative à vos données, vous pouvez écrire à{" "}
          <a className="text-brand hover:underline" href="mailto:contact@leadzi.fr">contact@leadzi.fr</a>.
        </p>
      </LegalSection>

      <LegalSection title="Données collectées sur ce site">
        <p>
          Ce site est un site vitrine. Il ne comporte pas de formulaire et ne collecte aucune donnée
          personnelle d'identification (nom, e-mail, téléphone) que vous nous transmettriez
          directement via le site.
        </p>
        <p>
          Seules des données de <strong>mesure d'audience</strong> sont collectées, de façon
          anonyme ou pseudonyme, afin de comprendre l'usage du site (pages consultées, type
          d'appareil, données techniques de navigation). Ces données ne permettent pas de vous
          identifier personnellement.
        </p>
      </LegalSection>

      <LegalSection title="Cookies & mesure d'audience">
        <p>
          Des cookies ou technologies similaires de mesure d'audience peuvent être déposés afin
          d'établir des statistiques de fréquentation. Vous pouvez à tout moment configurer votre
          navigateur pour refuser les cookies&nbsp;; ce refus n'affecte pas l'accès au contenu du site.
        </p>
      </LegalSection>

      <LegalSection title="Finalité et base légale">
        <p>
          Les données de navigation sont traitées à des fins de mesure d'audience et d'amélioration
          du site, sur la base de notre intérêt légitime à optimiser nos services.
        </p>
      </LegalSection>

      <LegalSection title="Durée de conservation">
        <p>
          Les données de mesure d'audience sont conservées pour une durée n'excédant pas celle
          nécessaire aux finalités statistiques, conformément aux recommandations de la CNIL.
        </p>
      </LegalSection>

      <LegalSection title="Vos droits">
        <p>
          Conformément au Règlement général sur la protection des données (RGPD) et à la loi
          « Informatique et Libertés », vous disposez d'un droit d'accès, de rectification,
          d'effacement, de limitation et d'opposition sur vos données. Vous pouvez exercer ces
          droits en écrivant à{" "}
          <a className="text-brand hover:underline" href="mailto:contact@leadzi.fr">contact@leadzi.fr</a>.
          Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).
        </p>
      </LegalSection>

      <LegalSection title="Application mobile Leadzi CHR">
        <p>
          Le traitement des données réalisé au sein de l'application mobile Leadzi CHR (dépôt et
          suivi des opportunités) est régi par les conditions et la politique de confidentialité
          propres à l'application, présentées lors de son utilisation.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
